import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRightIcon, LoaderIcon } from 'lucide-react';
const WAITLIST_URL = 'https://script.google.com/macros/s/AKfycbwh0J9Vkq6zT5v5-Pe-5GZczrP-7RSoI2ANR30Epc1TUMBa6CtWBK-Hu7W5Kn1EZVlOfw/exec';
export function FinalCTA() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name || !email) return;
    setStatus('loading');
    try {
      await fetch(WAITLIST_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          email
        })
      });
      setStatus('success');
      setName('');
      setEmail('');
      setTimeout(() => setStatus('idle'), 5000);
    } catch {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 4000);
    }
  };
  return <section id="waitlist" className="relative py-24 lg:py-32 bg-gray-950 overflow-hidden" data-id="element-17">
      {/* Background glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(251,191,36,0.08),transparent_60%)]" data-id="element-18" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} data-id="element-20">
          <div className="bg-white p-2 rounded-2xl w-24 h-24 mx-auto mb-6 flex items-center justify-center" data-id="element-21">
            <img src="https://cdn.magicpatterns.com/uploads/vpaWAD2nLEfW1hoAd36jz7/LPot_only.png" alt="KittyPot logo" className="w-16 h-16 object-contain" data-id="element-22" />
          </div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-5" data-id="element-23">
            Stop chasing.{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-kitty-yellow-400 to-orange-400" data-id="element-24">
              Start tracking.
            </span>
          </h2>
          <p className="text-lg lg:text-xl text-gray-400 mb-10 max-w-lg mx-auto" data-id="element-25">
            Be one of the first to try KittyPot. Join the waitlist for early MVP
            access and product updates.
          </p>

          {status === 'success' ? <motion.div initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-lg mx-auto mb-6 bg-green-500/10 border border-green-500/20 rounded-2xl px-6 py-4 flex items-center justify-center gap-3" data-id="element-26">
              <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-27" />
              <div className="text-left" data-id="element-28">
                <p className="text-green-300 font-semibold" data-id="element-29">
                  You're on the waitlist 🎉
                </p>
                <p className="text-green-400/60 text-sm mt-1" data-id="element-30">
                  We'll let you know as soon as KittyPot is ready. Early users
                  get first access.
                </p>
              </div>
            </motion.div> : <form onSubmit={handleSubmit} className="max-w-lg mx-auto mb-6 space-y-4" data-id="element-31">
              <input type="text" placeholder="Full name" value={name} onChange={e => setName(e.target.value)} className="w-full pl-5 pr-5 py-[14px] lg:py-4 min-h-[52px] rounded-full border border-white/20 bg-white/[0.08] focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-white placeholder-gray-400 text-base backdrop-blur-sm" required data-id="element-32" />
              <input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} className="w-full pl-5 pr-5 py-[14px] lg:py-4 min-h-[52px] rounded-full border border-white/20 bg-white/[0.08] focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-white placeholder-gray-400 text-base backdrop-blur-sm" required data-id="element-33" />
              <button type="submit" disabled={status === 'loading'} className="w-full bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark px-8 py-[16px] lg:py-4 min-h-[56px] rounded-full font-bold transition-all active:scale-[0.98] shadow-lg hover:shadow-xl flex items-center justify-center gap-2 text-base disabled:opacity-70 disabled:cursor-not-allowed mt-2" data-id="element-34">
                {status === 'loading' ? <LoaderIcon className="w-5 h-5 animate-spin" data-id="element-35" /> : <>
                    Join the waitlist
                    <ArrowRightIcon className="w-4 h-4" data-id="element-36" />
                  </>}
              </button>
              {status === 'error' && <p className="text-red-400 text-sm" data-id="element-37">
                  Something went wrong. Please try again.
                </p>}
            </form>}

          {/* Early access positioning */}
          <div className="flex flex-col items-center gap-4" data-id="element-38">
            <p className="text-sm text-gray-500" data-id="element-39">
              No spam. Just product updates and early access news.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}